// EstimateOptions (job page): an estimate's options side by side, as the customer saw them on the iPad:
// its letter, what it is, its price large, what comes with it. The one they signed is framed heavier
// and says so in words ("Option B · signed"), never by colour. Three across; one under another on a
// phone. A line under them says who presented it and who signed. Reads only --estopt-*.
import type { ReactNode } from 'react';
import './EstimateOptions.css';

export interface EstimateOption {
  id: string;
  /** "Option B". */
  name: string;
  title: string;
  price: string;
  points: string[];
  isSigned?: boolean;
}
export interface EstimateOptionsProps {
  options: EstimateOption[];
  foot?: ReactNode;
}

export function EstimateOptions({ options, foot }: EstimateOptionsProps) {
  return (
    <div className="fl-estopt">
      <ul className="fl-estopt__list">
        {options.map((o) => (
          <li key={o.id} className="fl-estopt__opt" data-signed={o.isSigned ? '' : undefined}>
            <span className="fl-estopt__name">{o.isSigned ? <b>{o.name} · signed</b> : o.name}</span>
            <span className="fl-estopt__title">{o.title}</span>
            <span className="fl-estopt__price">{o.price}</span>
            <ul className="fl-estopt__points">
              {o.points.map((p) => (
                <li key={p}>{p}</li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
      {foot ? <p className="fl-estopt__foot">{foot}</p> : null}
    </div>
  );
}
